import { ApolloCache } from "@apollo/client"

import { findParent, findParents } from "shared/lib/treeUtils"
import { ProjectTypename } from "shared/types/Project"

import { readProjectFragment } from "entities/projects/lib/readProjectFragment"

import { getProjectChildren } from "./getProjectChildren"

export function findParentRooms({
  projectID,
  childID,
  cache
}: {
  projectID: string
  childID: string
  cache: ApolloCache<object>
}) {
  const projectChildren = getProjectChildren(projectID, ProjectTypename, cache)
  const parents = findParents(childID, projectChildren)

  return parents || null
}

export function findProjectChildParent({
  projectID,
  childID,
  cache
}: {
  projectID: string
  childID: string
  cache: ApolloCache<object>
}) {
  const project = readProjectFragment(projectID, cache)
  const projectChildren = getProjectChildren(projectID, ProjectTypename, cache)
  const parent = findParent(childID, projectChildren, project)

  return parent || null
}
